import { useEffect, useRef } from 'react';

export function isGlobalChecklist(checklist) {
    return 'global' === checklist.checklisttype?.toLowerCase() || undefined === checklist.branding?.id;
}

export function isLegacyChecklist(checklist) {
    return 'branding' === checklist.checklisttype?.toLowerCase() || undefined !== checklist.branding?.id;
}

export function checklistNeedsUpgrade(checklist) {
    const json = checklist?.json ?? '';
    if (json === '{}') {
        return false;
    }

    return !json.includes('"$version"');
}

export function useAutosaveChanges(isDirty, saveCallback) {
    const timeout = useRef(null);

    useEffect(() => {
        if (!isDirty) {
            return;
        }

        timeout.current = setTimeout(() => {
            saveCallback();
        }, 1500);

        return () => {
            if (null === timeout.current) {
                return;
            }

            clearTimeout(timeout.current);
            timeout.current = null;
        };
    }, [ isDirty, saveCallback ]);
}
